module.exports = __webpack_public_path__ + "static/media/defaultAvatar2.42089799.svg";